import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { LocaleProvider } from '@op/opds.opux';
import i18next from 'i18next';
import './i18n/config';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

/**
 * Entry point for the React application.
 *
 * - Wraps the application with `BrowserRouter` to enable client-side routing using React Router.
 * - Uses `LocaleProvider` to provide the current i18n locale (from i18next) to the component tree,
 *   enabling locale-aware components and translations throughout the app.
 * - Renders the main `App` component inside React's `StrictMode` for highlighting potential problems.
 * - Optionally reports web vitals for performance monitoring.
 */

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LocaleProvider locale={i18next.language}>
        <App />
      </LocaleProvider>
    </BrowserRouter>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
